import React, { useEffect } from "react";
import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { FiUserPlus, FiEdit3, FiSliders, FiUsers, FiSend, FiAward, FiArrowRight } from "react-icons/fi";
import { createVotingHref } from "@lubbezposrednio-frontend/core";
import { InfoPage, InfoBody, InfoSectionTitle, NumberedSteps } from "../infoShared";

const STEPS = [
  { icon: FiUserPlus, title: "Załóż darmowe konto", desc: "Rejestracja zajmuje chwilę. Konto pozwala tworzyć i prowadzić własne głosowania." },
  { icon: FiEdit3, title: "Uruchom kreator", desc: "Dodaj tytuł i pytania — typu tak/nie, jednokrotnego lub wielokrotnego wyboru, z opcją wstrzymania się." },
  { icon: FiSliders, title: "Ustaw zasady ważności", desc: "Określ kworum (frekwencję), próg przyjęcia dla pytań oraz tajność — tajne lub jawne imienne." },
  { icon: FiUsers, title: "Wybierz uprawnionych", desc: "Wgraj listę, otwórz zapisy (vox populi) albo wymagaj weryfikacji tożsamości. Możesz też dopisać osoby ręcznie." },
  { icon: FiSend, title: "Opublikuj głosowanie", desc: "Zaproszenia wychodzą automatycznie o czasie startu. Uczestnicy głosują bez zakładania konta." },
  { icon: FiAward, title: "Odbierz wiarygodny wynik", desc: "Po zakończeniu dostajesz protokół zakotwiczony na blockchainie i podpisany PDF — gotowy do dokumentacji." }
];

export const HowToCreateVotingView: React.FC = () => {
  useEffect(() => {
    document.title = "Jak stworzyć głosowanie";
  }, []);

  return (
    <InfoPage
      eyebrow="Dla organizatorów"
      title="Jak stworzyć głosowanie"
      subtitle="Od konta do wiarygodnego wyniku — bez technicznej wiedzy. Kreator prowadzi Cię krok po kroku."
    >
      <InfoBody narrow>
        <InfoSectionTitle>Krok po kroku</InfoSectionTitle>
        <NumberedSteps steps={STEPS} />

        <Flex
          mt={{ base: "48px", md: "64px" }}
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="space-between"
          gap="18px"
          bgGradient="linear(135deg, #430098 0%, #6a1fc2 100%)"
          borderRadius="22px"
          px={{ base: "28px", md: "40px" }}
          py={{ base: "30px", md: "34px" }}
          color="white"
          textAlign={{ base: "center", md: "left" }}
        >
          <Box>
            <Heading fontSize={{ base: "21px", md: "24px" }} fontWeight="800">
              Gotowy, żeby zacząć?
            </Heading>
            <Text fontSize="15px" color="rgba(255,255,255,0.85)" mt="3px">
              Pierwsze głosowanie stworzysz w kilka minut.
            </Text>
          </Box>
          <Button as={Link} to={createVotingHref()} bg="white" color="primary" borderRadius="12px" fontWeight="800" px="26px" py="14px" h="auto" flexShrink={0} rightIcon={<FiArrowRight />} _hover={{ bg: "rgba(255,255,255,0.9)" }}>
            Stwórz głosowanie
          </Button>
        </Flex>
      </InfoBody>
    </InfoPage>
  );
};
